module.exports = __webpack_public_path__ + "img/abt_img.c356f6da.jpg";